import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=dc0f0e84&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Profile.vue?vue&type=style&index=1&id=dc0f0e84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0f0e84",
  null
  
)

export default component.exports